module.exports = __webpack_public_path__ + "img/203-34181a.png";